import React, { memo } from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { InfiniteScrollLoader } from "./InfiniteScrollLoader"

export type InfiniteScrollerProps = {
  data: any[]
  scrollableContainerId: string
  onLoad: () => void
  hasMore: boolean
  loading: boolean
  loadMoreText: string
}

export const InfiniteScroller = memo((props: InfiniteScrollerProps) => {
  const { data, scrollableContainerId, hasMore, loading, loadMoreText, onLoad } = props

  return (
    <InfiniteScroll
      dataLength={data.length}
      next={onLoad}
      hasMore={hasMore}
      loader={loading && <InfiniteScrollLoader loadMoreText={loadMoreText} />}
      scrollableTarget={scrollableContainerId}
    >
      <div></div>
    </InfiniteScroll>
  )
})
